import SemDetailIMG from "../assets/home.png";
import MealStoreIMG from "../assets/MealStore.png";
import TravelEliteIMG from "../assets/all_users.png";
import RFIDModelIMG from "../assets/download.jpeg";
import MaptyIMG from "../assets/Mapty.png";
import CarGameIMG from "../assets/CarGame.png";
import MeetupAppIMG from "../assets/MeetupApp.png";
import DesiBirdsIMG from "../assets/DesiBirds.png";
import PokeAuthIMG from "../assets/Poke-Auth.png";
import NatoursIMG from "../assets/Natours.png";
import PigGameIMG from "../assets/PigGame.png";

const projectList = [
  {
    id: 1,
    title: "TravelELite",
    img: TravelEliteIMG,
    tech: ["ReactJS", "Express", "MongoDB"],
    desc: "TravelElite is a web application based on the MERN-(MongoDB, ExpressJS, ReactJS, NodeJS) tech stack. This application aims to connect people who like to travel and allows them store their captured memories on the site. A user can create his/her profile and upload the photos of pictures they have visited along with some relevant information about it.",
    link: "https://github.com/p-chhabra/TravelELite",
  },
  {
    id: 2,
    title: "SemDetail",
    img: SemDetailIMG,
    tech: ["NextJS", "MongoDB", "Tailwind"],
    desc: "Semester Detail Website is an online platform where a student can access the details related to different courses of all semesters with comfort and ease. It contains information on various fronts for all courses in a user friendly and easy to navigate manner",
    link: "https://github.com/p-chhabra/Semester-Detail-Website/tree/dev",
  },
  {
    id: 3,
    title: "RFID Model",
    img: RFIDModelIMG,
    tech: ["Arduino", "NodeJS", "ReactJS"],
    desc: "The RFID Attendance System is a project that allows you to track the attendance of students using RFID technology. This system uses an Arduino board, Node.js, Express, Mongoose, and React to capture RFID data, store it in a database, and display a list of present students in a web interface.",
    link: "https://github.com/p-chhabra/RFID-Attendance-system",
  },
  {
    id: 4,
    title: "Meal Store",
    img: MealStoreIMG,
    tech: ["ReactJS", "Firebase"],
    desc: "An online food store on which users can add their favorite food items to their cart and place an order. Made using ReactJS and Firebase. Used the Redux to manage app wide state and firebase as database to fetch meal items",
    link: "https://github.com/p-chhabra/Food-Order-App",
  },
  {
    id: 5,
    title: "Mapty",
    img: MaptyIMG,
    tech: ["Vanilla JS", "LeafletJS"],
    desc: "A map workout application which allows users to mark their workout location on the map and save it. The application uses the LeafletJS library to display the map. The application also uses the local storage to store the data of the user.",
    link: "https://github.com/p-chhabra/Map-Workout-Application",
  },
  {
    id: 6,
    title: "Poke-Auth",
    img: PokeAuthIMG,
    tech: ["NextJS", "Firebase"],
    desc: "This is an application built using NextJS and with the help of Firebase authentication and Firstore Database. It allows users to create an account and view a list of pokemons on the screen.",
    link: "https://github.com/p-chhabra/Poke-Auth-App",
  },
  {
    id: 7,
    title: "Meetup App",
    img: MeetupAppIMG,
    tech: ["NextJS", "MongoDB"],
    desc: "A simple Nextjs app built for practice purposes. Used MongoDb Atlas as the database to store and fetch data",
    link: "https://github.com/p-chhabra/NextJS-Meetup-App",
  },
  {
    id: 8,
    title: "Natours",
    img: NatoursIMG,
    tech: ["HTML", "SCSS"],
    desc: "A Static webiste on Tourism designed using scss. Contains information about different tours. Contains a booking section",
    link: "https://github.com/p-chhabra/Natours",
  },
  {
    id: 9,
    title: "Desi Birds",
    img: DesiBirdsIMG,
    tech: ["Unity", "C#"],
    desc: `This is the first ever project I created using Unity Engine with C#. (Its just a simple fun little game) I've tried to mimic the famous android game 'Angry Birds'. This game is pretty similar, except that it runs on windows and has only few levels sweat_smile.`,
    link: "https://github.com/p-chhabra/Desi-Birds",
  },
  {
    id: 10,
    title: "Blogger",
    img: MaptyIMG,
    tech: ["ReactJS", "MongoDB", "ExpressJS"],
    desc: "A blog app which allows users to post blogs with special text features. Frontend is built using ReactJS and Tailwind CSS with some third party npm packages and a tinymce text editor.",
    link: "https://github.com/p-chhabra/Eqaim-Blogs",
  },
  {
    id: 11,
    title: "Car Game",
    img: CarGameIMG,
    tech: ["Vanilla JS", "HTML"],
    desc: "A car game where the player has to avoid obstacles and gain score. The game ends when the car hits an obstacle.",
    link: "https://github.com/p-chhabra/Car-Game",
  },
  {
    id: 12,
    title: "Pig Game",
    img: PigGameIMG,
    tech: ["Vanilla JS", "HTML", "CSS"],
    desc: "A 1v1 game played with the opponent with dice throws. First to reach a 100 score wins the game. Built using HTML and vanilla js to implement logic",
    link: "https://github.com/p-chhabra/Pig-Game",
  },
];

export default projectList;
